import { ComponentBase } from 'app/shared/lib/essette-site';
import { autoinject, bindable } from 'aurelia-framework';
import * as Core from 'app/core/models/essette-api';
import { hasErrorMessages, hasSourceInfo } from 'app/core/components/summary/job/import-staged-table';

@autoinject()
export class StagedRecordDetails extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable
    protected sourceInfo: Core.StagedContainer | null = null;

    @bindable
    protected errorInfo: Core.ErrorContainer | null = null;

    protected hasSource: boolean = false;
    protected hasError: boolean = false;
    protected hasSourceInfo = hasSourceInfo;
    protected hasErrorMessages = hasErrorMessages;

    constructor(...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.hasSource = hasSourceInfo(this.sourceInfo);
        this.hasError = hasErrorMessages(this.errorInfo);
    }

}
